// **************************************************************** //
// FLAMINGO ESTATE
// PAGE - FEAST OF VENUS
// **************************************************************** //

var fov_pdf_d = '//flamingoestate.com/cdn/shop/files/feast-of-venus--desktop--v5.pdf?v=2466312170854109938';
var fov_pdf_m = '//flamingoestate.com/cdn/shop/files/feast-of-venus--mobile--v5.pdf?v=14693466211292663490';

var pdfjsLib = window['pdfjs-dist/build/pdf'];
pdfjsLib.GlobalWorkerOptions.workerSrc = '//flamingoestate.com/cdn/shop/t/232/assets/pdf.worker.js?v=64995490514146016791725383549';

function loadpdf(url, dm, onComplete) {
	this.url = url;
	this.dm = dm;
	
	this.mains_container = '#pfov' + this.dm + '_mains';
	this.thumbs_container = '#pfov' + this.dm + '_thumbs';
	this.pdfDoc = null;
	this.pageNum = 1;
	this.pageRendering = false;
	this.pageNumPending = null;
	this.queue_next_page = 0;
	if(window.devicePixelRatio > 2) {
		this.scale = 0.85;
	}
	else {
		this.scale = 1.5;
	}
	this.page_count;
	this.complete_counter = 0;
	
	this.onComplete = onComplete || null;
}

loadpdf.prototype.renderPage = function(num, target) {
	
	this.pageRendering = true;
	
	var canvas = target;
	var ctx = canvas.getContext('2d');
	var renderContext;
	var viewport;
	var renderTask;
	
	this.pdfDoc.getPage(num).then(function(page) {
		var viewport = page.getViewport({scale: this.scale});
		canvas.height = viewport.height;
		canvas.width = viewport.width;
		renderContext = {
			canvasContext: ctx,
			// background: 'rgba(0, 0, 0, 0)',
			viewport: viewport
		};
		renderTask = page.render(renderContext);
		renderTask.promise.then(function() {
						
			$('#pfov_pdf_' + this.dm + '_main_' + num).removeClass('Image--lazyLoading');
			$('#pfov_pdf_' + this.dm + '_main_' + num).removeClass('Image--lazyLoaded');
			
			this.pageRendering = false;
			this.complete_counter++;
			console.log( '[' + this.dm + '] this.complete_counter', this.complete_counter );
			
			if(this.complete_counter < this.pdfDoc.numPages) {
				this.queue_next_page = this.complete_counter + 1;
				// create container
				$(this.mains_container).append('<div class="pfov_' + this.dm + '_main pfov_pdf_main_' + this.queue_next_page + '"><canvas id="pfov_pdf_' + this.dm + '_main_' + this.queue_next_page + '"></canvas></div>');
				// render page
				this.renderPage(this.queue_next_page, document.getElementById('pfov_pdf_' + this.dm + '_main_' + this.queue_next_page));
			}
			
			/*
			if(this.complete_counter == this.page_count * 2) {
				this.onComplete.bind(this)();
				// console.log( '--- DONE ! ---' );
			}
			else {
				// console.log( 'not done yet...' );
			}
			*/
		}.bind(this));
	}.bind(this));
}

loadpdf.prototype.init = function() {
	pdfjsLib.getDocument(this.url).promise.then(function(pdfDoc_) {
		
		// hide mains loading (for this instance: desktop or mobile)
		$('#pfov' + this.dm + '_pdf_loading_placeholder').removeClass('Image--lazyLoading');
		$('#pfov' + this.dm + '_pdf_loading_placeholder').addClass('Image--lazyLoaded');
		$('#pfov' + this.dm + '_pdf_loading').css('display', 'none');
		// show mains container (for this instance)
		$('#pfov' + this.dm + '_mains').css('display', 'block');
		
		this.pdfDoc = pdfDoc_;
		this.page_count = this.pdfDoc.numPages;
		
		// create container
		$(this.mains_container).append('<div class="pfov_' + this.dm + '_main pfov_pdf_main_' + 1 + '"><canvas id="pfov_pdf_' + this.dm + '_main_' + 1 + '"></canvas></span></div>');
		// render page
		this.renderPage(1, document.getElementById('pfov_pdf_' + this.dm + '_main_' + 1));
		
	}.bind(this));
}